module.exports = __webpack_public_path__ + "plat/static/img/login_bg_ghw.24b6bd38.jpg";